import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=23f0a859"
import script from "./ListItem.vue?vue&type=script&lang=js"
export * from "./ListItem.vue?vue&type=script&lang=js"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=23f0a859&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports